import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import "./subServices.css";
import Footer from "../../../../components/Footer/Footer";
import ContactUsFooter from "../../../../components/ContactUsFooter/contactUsFooter";

function SubServices() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const serviceType = params.get("service");

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    let pageTitle = "Smart City \nand Infrastructure Solutions";
    let introHeading = "Transform Urban Life with Our Smart City &\n Infrastructure Solutions";
    let introText = "At Ambrum, we design digital infrastructure that enhances urban living through smart systems, sustainable planning, and connected technologies. From public service automation to smart grids, we build cities of tomorrow.";
    let expertiseText = "We’ve worked with government and private stakeholders to digitize services, implement geolocation-based monitoring, and enable data-driven city operations—building efficiency, transparency, and growth.";

    if (serviceType === "ev-charging") {
        pageTitle = "EV Charging and\n Sustainable Tech Solutions";
        introHeading = "Drive the Future\n EV Charging and Green Tech Solutions by Ambrum";
        introText = "As sustainability becomes a global imperative, Ambrum leads with EV charging innovations and smart energy platforms that enable eco-friendly infrastructure and cleaner mobility.";
        expertiseText = "With our proprietary Voltcharge platform, we’ve empowered charging providers to expand effortlessly with smart station discovery, real-time monitoring, and smooth payments.";
    } else if (serviceType === "healthcare") {
        pageTitle = "Healthcare and\n E-Channeling Solutions";
        introHeading = "Revolutionizing Healthcare Access with\n E-Channeling & Digital Health Platforms";
        introText = "Ambrum delivers seamless healthcare experiences through custom-built doctor channeling apps, medical record management systems, and patient-centric platforms.";
        expertiseText = "Our flagship product, Find My Doc (FMD), has streamlined patient journeys for thousands. From mobile-first booking to backend clinic management, we deliver end-to-end healthcare tech.";
    } else if (serviceType === "e-ticketing") {
        pageTitle = "E-Ticketing and \nEvent Management Solutions";
        introHeading = "Simplify Events with Smart E-Ticketing &\n Event Tech Solutions";
        introText = "From concerts to conferences, Ambrum powers unforgettable experiences with digital ticketing, seamless entry systems, and event organizer platforms.";
        expertiseText = "We’ve built platforms for large-scale events with thousands of attendees, integrating payment, check-in, and marketing into one smooth ecosystem.";
    } else if (serviceType === "digital-marketing") {
        pageTitle = "Performance-Driven \nDigital Marketing";
        introHeading = "Marketing that Delivers\n Results.";
        introText = "At Ambrum Marketing, we go beyond likes and impressions—we deliver ROI. Our data-driven campaigns combine creativity with strategy to grow your brand and revenue.";
        expertiseText = "We’ve grown local brands into global players using a blend of smart targeting, behavioral data, and high-converting creative assets.";
    } else if (serviceType === "brand-strategy") {
        pageTitle = "Brand Strategy and\n Identity Development";
        introHeading = "Build a Brand That\n Resonates, Grows, and Lasts";
        introText = "From positioning to visual identity, Ambrum helps you craft a brand that connects with people, stands out in the market, and supports long-term growth.";
        expertiseText = "We’ve shaped new brands from scratch and helped legacy ones evolve, always tying branding back to business objectives and audience psychology.";
    } else if (serviceType === "social-media") {
        pageTitle = "Content and \nSocial Media Growth";
        introHeading = "Content That Connects.\nSocial That Converts.";
        introText = "We help brands grow online by creating content that matters—stories that spark engagement, build community, and lead to measurable business outcomes.";
        expertiseText = "From startups to established businesses, we’ve scaled online presence across Instagram, LinkedIn, TikTok, and Pinterest with platform-native content.";
    } else if (serviceType === "e-commerce") {
        pageTitle = "E-Commerce and \nConversion Optimization";
        introHeading = "Turn Clicks Into Customers with Optimized E-\nCommerce Solutions";
        introText = "We build high-performing e-commerce experiences that convert visitors into loyal customers through sleek UX, CRO tactics, and full-funnel strategy.";
        expertiseText = "We’ve helped brands boost online sales by over 300% through strategic design, psychological triggers, and performance marketing.";
    }

    return (
        <div>
            <div className="sub-service-page">
                <section className="sub-service-hero">
                    <h1>{pageTitle}</h1>
                </section>

                <section className="sub-service-intro">
                    <h2>{introHeading}</h2>
                    <p>{introText}</p>
                </section>

                <section className="sub-service-why-choose">
                    <h3>Our Expertise</h3>
                    <p>{expertiseText}</p>
                </section>

                <section className="sub-service-approach">
                    <h3>Our Approach</h3>
                    <div className="sub-service-approach-steps">
                        <div>
                            <h4>Requirement Analysis</h4>
                            <br />
                            <p>Understanding business <br /> objectives and defining <br />technical requirements</p>
                        </div>
                        <div className="sub-service-approach-arrow">
                            <img src="../assets/images/fast-forward.gif" alt="Arrow" />
                        </div>
                        <div>
                            <h4>Custom Development</h4>
                            <br />
                            <p>Agile development <br />methodology ensuring <br />flexibility and scalability</p>
                        </div>
                        <div className="sub-service-approach-arrow">
                            <img src="../assets/images/fast-forward.gif" alt="Arrow" />
                        </div>
                        <div>
                            <h4>Testing & Deployment</h4>
                            <br />
                            <p>Rigorous quality assurance <br /> to ensure flawless execution</p>
                        </div>
                    </div>
                </section>

                <div className="sub-service-cta-section">
                    <Link to="/portfolio" className="cta-button">View Projects ❯</Link>
                </div>
                <ContactUsFooter />
                <br />
            </div>
            <Footer />
        </div>
    );
}

export default SubServices;
